import axios from 'axios';
import CryptoJS from 'crypto-js';
import { API_GET_ALL_FACILITY_DETAILS, API_GET_ALL_LOCATION_DETAILS, API_GET_ALL_SHOP_DETAILS } from '../../constants/apiConstant';

const apiService = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

const decryptData = (encryptedData) => {
    try {
        return JSON.parse(
            CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_ENCRYPTION_SECRET).toString(CryptoJS.enc.Utf8)
        );
    } catch (error) {
        console.error('Error decrypting data:', error);
        throw new Error('Failed to decrypt data');
    }
};

export const fetchLocations = async () => {
    try {
        const response = await apiService.get(API_GET_ALL_LOCATION_DETAILS);
        return decryptData(response.data.data).locations;
    } catch (error) {
        console.error('Error fetching locations:', error);
        throw new Error('Failed to fetch locations');
    }
};

export const fetchFacilities = async () => {
    try {
        const response = await apiService.get(API_GET_ALL_FACILITY_DETAILS);
        return decryptData(response.data.data).facilities;
    } catch (error) {
        console.error('Error fetching facilities:', error);
        throw new Error('Failed to fetch facilities');
    }
};

export const fetchShops = async (params) => {
    try {
        const validatedParams = {
            page: params.page || 1,
            limit: params.limit || 5,
            search: params.search || '',
            language: params.language || 'en',
        };

        const response = await apiService.get(API_GET_ALL_SHOP_DETAILS, { params: validatedParams });
        const decryptedShops = decryptData(response.data.data.shops);

        return {
            shops: decryptedShops,
            totalShops: response.data.data.totalShops,
        };
    } catch (error) {
        console.error('Error fetching shops:', error);
        throw new Error('Failed to fetch shops');
    }
};